<template>
  <transition name="modal">
    <div class="modal-mask" v-if="show">
      <div class="modal-wrapper" @click.self="onClose">
        <div class="modal-container">
          <div class="close-container">
            <img
              src="@/assets/img/1x/close.svg"
              @click="onClose"
              alt="Cerrar"
            />
          </div>
          <div class="modal-header" :class="labelAlign">
            <slot name="header">
              <div class="header-text">
                <h3>{{ label }}</h3>
              </div>
            </slot>
          </div>

          <div class="modal-content">
            <form-validator>
              <div
                class="modal-body"
                v-bind:class="{
                  scroll: bodyScroll,
                  terms: terms,
                  large: large,
                  short: !large
                }"
              >
                <slot name="body">
                  <slot />
                </slot>
              </div>

              <div class="modal-footer" :class="buttonAlign">
                <slot name="footer">
                  <sales-button
                    color="#1973b8"
                    class="boton"
                    @click="aceptar"
                    :label="buttonLabel"
                    :disable="disable"
                  />
                </slot>
              </div>
            </form-validator>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import FormValidator from "@/components/core/FormValidator";
import SalesButton from "@/components/core/SalesButton";
export default {
  name: "ModalComponent",
  components: {
    FormValidator,
    SalesButton
  },
  props: {
    label: String,
    labelAlign: {
      type: String,
      default: "center"
    },
    buttonLabel: String,
    buttonAlign: {
      type: String,
      default: "center"
    },
    bodyScroll: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Boolean,
      default: false
    },
    modalBody: String,
    large: {
      type: Boolean,
      default: false
    }
  },
  beforeUpdate() {
    if (this.show) {
      document.getElementsByTagName("html")[0].classList.add("lock-scroll");
    } else {
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
    }
  },
  mounted() {
    document.body.addEventListener("keyup", e => {
      if (e.key === "Escape") {
        this.onClose();
      }
    });
  },
  methods: {
    onClose() {
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
      this.$emit("close");
    },
    aceptar() {
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
      if (this.$listeners.aceptar) {
        this.$emit("aceptar");
      } else {
        this.$emit("close");
      }
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  justify-content: center;
}

.modal-wrapper {
  align-self: center;
}

.modal-container {
  text-align: left;
  padding: 40px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  box-sizing: border-box;
  position: relative;
}

.short {
  width: 100%;
  max-width: 600px;
  max-height: 200px;
}

.large {
  width: 85vw;
  max-width: 1200px;
  max-height: 50vh;
}

.modal-container .modal-body {
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 17px;
}

.header-text {
  width: 90%;
}

/* Tamaño del scroll */
.modal-body::-webkit-scrollbar {
  width: 0.5em;
}
/* Estilos barra (thumb) de scroll */
.modal-body::-webkit-scrollbar-thumb {
  background: #8a8a8a;
  margin: 100px;
  border-radius: 4px;
}
.modal-body::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}
/* Estilos track de scroll */
.modal-body::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
}

.modal-header h3 {
  font-size: 26px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  white-space: normal;
  object-fit: contain;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #121212;
  margin-top: 0;
}

.modal-header.center h3 {
  text-align: center;
}
.modal-header.left h3 {
  text-align: left;
}
.modal-header.right h3 {
  text-align: right;
}

.modal-body {
  margin: 20px auto;
  padding: 0 5px;
}
.modal-body.scroll {
  overflow-y: auto;
}

.modal-footer.center {
  text-align: center;
}
.modal-footer.left {
  text-align: left;
}
.modal-footer.right {
  text-align: right;
}

/* Boton cerrar */
div.close-container {
  text-align: right;
  position: absolute;
  right: 40px;
  top: 40px;
}

div.close-container * {
  cursor: pointer;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 600px) {
  /* En mobile el modal ocupa toda la pantalla */
  .modal-wrapper {
    align-self: stretch;
    width: 100%;
  }

  .modal-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }
  .modal-content {
    padding: 16px;
    flex: 1; /* Stretch */
    min-height: 1%; /* Hack: fuerza al hijo flex a tener altura máxima dentro de su contenedor */
  }

  .modal-content form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .modal-body {
    margin-top: 10px;
    flex: 1;
    max-height: none;
  }

  .modal-header {
    padding: 0 16px;
    box-shadow: 0 1px 0 0 #e9e9e9;
  }
  .modal-header h3 {
    font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  div.close-container {
    position: absolute;
    right: 16px;
    top: 13px;
  }

  .modal-body.scroll.short {
    white-space: normal;
    font-size: 1.5rem;
    line-height: normal;
  }

  .boton {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  h3 {
    margin-top: 0;
    margin-bottom: 23px;
  }

  .boton {
    width: 163px;
  }
}
</style>
